import * as request from "../utils/request"
import * as helper from "../utils/helper"
import * as aes from "../utils/aes"
import * as uuid from "../utils/uuid"
import * as storeConfigApi from "./store-config"
import * as langs from "../constants/langs"
import * as url from "../utils/url"
import "es6-promise/auto"

// Common Params
const commonParams = {
  pfkey: "pfkey",
  from_h5: 1,
  wx_direct_pay: 0,
  wx_publice_pay: 1,
  pay_method: "wechat",
  accounttype: "common",
  from_https: 1
}

const commonOrderParams = {
  pfkey: "pfkey",
  from_h5: 1,
  // wx_direct_pay: 0,
  // wx_publice_pay: 1,
  // pay_method: "wechat",
  // accounttype: "common",
  from_https: 1
}

/**
 * 获取游戏币绑定包月物品配置信息
 * @param {*} param0
 */
export function getGamecoinPlusGoodsInfo() {
  let storeConfigEnv = url.getParam("store_config_env")
  return Promise.resolve().then(() => {
    if (storeConfigEnv > 0) {
      return storeConfigApi.getConfigFromPayUrl({
        configUrl: `//sandbox.pay.qq.com${langs.GAMECOIN_BIND_CONFIG_URL_PATH}`,
        configUrlParam: {}
      })
    } else {
      return Promise.resolve().then(() => {
        return window.__midasStaticConfig_game_coin_plus
      })
    }
  })
}

/**
 * 首页浏览器内的猜你喜欢
 * @returns {Promise<T>}
 */
export function getGuessYouLikeGameList() {
  let storeConfigEnv = url.getParam("store_config_env")
  return Promise.resolve().then(() => {
    if (storeConfigEnv > 0) {
      return storeConfigApi.getConfigFromPayUrl({
        configUrl: `//sandbox.pay.qq.com${langs.INDEX_GUESS_YOU_LIKE}`,
        configUrlParam: {}
      })
    } else {
      return storeConfigApi.getConfigFromPayUrl({
        configUrl: `//pay.qq.com${langs.INDEX_GUESS_YOU_LIKE}`,
        configUrlParam: {}
      })
    }
  })
}

export function getGameInfo(params, extend = {}) {
  // mobile_buy_page不支持第三方登录态，目前有场景：快手内打开王者商城，故使用游客登录态查
  if (params.session_type == "st_local_third_party") {
    params = {
      ...params,
      openid: "openid",
      openkey: "openkey",
      session_id: "hy_gameid",
      session_type: "st_dummy"
    }
  }

  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)

    params = helper.extend(
      {
        pf: `${params.pfSource}-${params.urlPf}-${params.clientVersion || "html5"}`,
        pfkey: "pfkey",
        from_https: 1,
        from_h5: 1,
        wx_appid: params.wxAppid2,
        zoneid: params.zoneid || (params.mobileSelectRole ? "1_ext" : 1),
        buy_quantity: 1000,
        accounttype: params.offerId == "1450000186" ? "qb" : "common"
      },
      params,
      extend,
      aes.encrypt(params, ["openid", "openkey", "session_id", "session_type"], params.sandbox)
    )

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/mobile_buy_page`,
        data: params,
        type: "post"
      })
      .then(
        res => {
          if (res.ret == 0) {
            resolve(res.info)
          } else {
            reject(res)
          }
        },
        () => {
          reject({
            msg: "timeout"
          })
        }
      )
  })
}

export function qbRechargeByWechat(params) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)

    params = helper.extend(
      {
        pf: params.pf,
        pfkey: "pfkey",
        from_https: 1,
        from_h5: 1,
        zoneid: 1,
        service_name: "Q币",
        accounttype: "qb",
        webversion: "h5storeV1.0.0",
        pay_method: "wechat",
        wx_direct_pay: 0,
        wx_publice_pay: 1,
        buy_quantity: params.quantity,
        provide_uin: params.provide_uin,
        wx_appid: params.wxAppid2,
        wcp: `amt=${params.displayPrice}`,
        cr_flex: 1
      },
      params,
      aes.encrypt(params, ["openid", "openkey", "session_id", "session_type"], params.sandbox)
    )

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/mobile_save`,
        data: params,
        type: "post"
      })
      .then(
        res => {
          if (res.ret == 0) {
            resolve(res.wx_info)
          } else {
            reject(res)
          }
        },
        () => {
          reject({
            msg: "timeout"
          })
        }
      )
  })
}

/**
 * pcGameRechargeByWechat
 * 直连 cgi 下单游戏币相关
 * @param params
 * @returns {Promise<any>}
 */
export function pcGameRechargeByWechat(params, fkParams) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)
    let urlParams = {
      pf: params.pf,
      ...commonParams,
      zoneid: params.zoneid,
      buy_quantity: params.n,
      // service_name: params.service_name,
      provide_uin: params.u,
      discountid: params.mpid ? params.mpid : "",
      wcp: `amt=${params.refer_amt}`,
      game_info_mode: 1,
      webversion: params.webversion || "h5storeV1.0.0",
      drm_info: `currency_group=${params.groupid || ""}`,
      ...helper.getLoginState({
        openid: params.openid,
        openkey: params.openkey,
        sessionId: params.sessionid,
        sessionType: params.sessiontype,
        wxAppid2: params.wxAppid2
      }),
      cr_flex: 1
    }

    urlParams = helper.extend(
      urlParams,
      fkParams,
      aes.encrypt(
        urlParams,
        [
          "token_id",
          "openid",
          "openkey",
          "session_id",
          "session_type",
          "zoneid",
          "pay_method",
          "buy_quantity",
          "mb_pwd",
          "pay_id",
          "auth_key",
          "card_value",
          "accounttype"
        ],
        params.sandbox
      )
    )

    if (params.aid) {
      urlParams = helper.extend(urlParams, { aid4open: params.aid })
    }

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.appid}/mobile_save`,
        data: urlParams,
        type: "post"
      })
      .then(
        res => {
          if (res.ret == 0) {
            resolve(res.wx_info)
          } else {
            reject(res)
          }
        },
        () => {
          reject({
            msg: "timeout"
          })
        }
      )
  })
}

/**
 * 直连 Cgi 进行手游充值
 * 需先获取 token
 * @param params
 * @returns {Promise<any>}
 * 相较于pc下单：多了 change_wx_appid 用于转 commid
 * 少了 provide_uin 字段
 * 为了方便以后扩展，这里还是抽成为2个接口
 */
export function mobileGameRechargeByWechat(params, fkParams) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)

    let urlParams = {
      change_wx_openid: 1,
      pf: params.pf,
      ...commonParams,
      zoneid: params.zoneid,
      buy_quantity: params.n,
      // service_name: params.service_name,
      provide_uin: params.u,
      discountid: params.mpid ? params.mpid : "",
      wcp: `amt=${params.refer_amt}`,
      drm_info: `currency_group=${params.groupid || ""}`,
      webversion: params.webversion || "h5storeV1.0.0",
      ...helper.getLoginState({
        openid: params.openid,
        openkey: params.openkey,
        sessionId: params.sessionid,
        sessionType: params.sessiontype,
        wxAppid2: params.wxAppid2
      }),
      cr_flex: 1
    }

    urlParams = helper.extend(
      urlParams,
      fkParams,
      aes.encrypt(
        urlParams,
        [
          "token_id",
          "openid",
          "openkey",
          "session_id",
          "session_type",
          "zoneid",
          "pay_method",
          "buy_quantity",
          "mb_pwd",
          "pay_id",
          "auth_key",
          "card_value",
          "accounttype"
        ],
        params.sandbox
      )
    )

    if (params.aid) {
      urlParams = helper.extend(urlParams, { aid4open: params.aid })
    }

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.appid}/mobile_save`,
        data: urlParams,
        type: "post"
      })
      .then(
        res => {
          if (res.ret == 0) {
            resolve(res.wx_info)
          } else {
            reject(res)
          }
        },
        () => {
          reject({
            msg: "timeout"
          })
        }
      )
  })
}

/**
 * 道具直购下单获取token
 * @param params
 * @returns {Promise<any>}
 */
export function getActivityProcToken(params, extendParams) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)
    let data = {
      from_https: 1,
      from_h5: 1,
      pf: params.pf,
      pfkey: "pfkey",
      openid: params.openid,
      openkey: params.openkey,
      session_id: params.sessionId,
      session_type: params.sessionType,
      wx_appid: params.wxAppid2,
      qq_appid: params.qqAppid || ""
    }
    data = Object.assign(data, aes.encrypt(data, ["openid", "openkey", "session_id", "session_type"], params.sandbox))
    if (extendParams) {
      data = Object.assign(data, extendParams)
    }
    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/activity_proc`,
        data: data
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

/**
 * 直连 Cgi 进行手游游戏内货币（如金币）购买道具
 * 需先获取 token
 * @param params
 * @returns {Promise<any>}
 * @param {String} opt._params 取token得到的url_params
 * @param {String} opt._url 从mobile_goods_info得到的url_params
 * @param {String} opt._mid 机器的mid，与opt._url不共同存在
 * @param {String} opt.token_id token
 * @param {String} opt.pay_method 渠道
 * @param {Int} opt.buy_quantity 购买数量
 * @param {String} opt.h5_mb_url 密保的url
 * @param {Int} opt.wx_direct_pay 是否是微信直接支付
 * @param {Int} opt.wx_publice_pay 是否是微信支付
 * @param {String} opt.discountid 营销活动号
 * @param {String} opt.biz_appid 微信appid
 * @param {String} opt.pushtype
 * @param {String} opt.uuid
 */
export function gamePropRechargeByInGameCoin(params, activityProcToken) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)

    let urlParams = {
      pay_method: "ingame_coin:1",
      _mid: activityProcToken.mid,
      token_id: activityProcToken.token,
      change_wx_openid: 1,
      pf: params.pf,
      ...commonOrderParams,
      wcp: encodeURIComponent(`amt=${params.refer_amt}`),
      buy_quantity: params.buy_quantity,
      ...helper.getLoginState({
        openid: params.openid,
        openkey: params.openkey,
        sessionId: params.sessionId,
        sessionType: params.sessionType,
        wxAppid2: params.wxAppid2,
        qqAppid: params.qqAppid
      }),
      webversion: params.webversion || "h5storeV1.0.0"
    }
    if (params.drm_info) urlParams.drm_info = params.drm_info
    urlParams = Object.assign(urlParams, aes.encrypt(urlParams, ["openid", "openkey", "session_id", "session_type"], params.sandbox))

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/${urlParams._mid}/${params.offerId}/mobile_save_goods`,
        data: urlParams,
        type: "post"
      })
      .then(
        res => {
          if (res.ret == 0) {
            resolve(res)
          } else {
            reject(res)
          }
        },
        () => {
          reject({
            msg: "timeout"
          })
        }
      )
  })
}

/**
 * 索要下单获取token
 * @param params
 * @returns {Promise<any>}
 * 参数参考https://iwiki.woa.com/pages/viewpage.action?pageId=914481884
 */
export function getMobileGetToken(params, extendParams) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)
    let data = {
      ...commonOrderParams,
      pf: params.pf,
      ...helper.getLoginState(params.loginState)
    }
    data = Object.assign(data, aes.encrypt(data, ["openid", "openkey", "session_id", "session_type"], params.sandbox))
    if (extendParams) {
      data = Object.assign(data, extendParams)
    }
    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/mobile_get_token`,
        data: data
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(err => {
        reject({
          msg: "timeout",
          err: err
        })
      })
  })
}

/**
 * 查询活动信息
 * mobile_mp_info
 * @param params
 * @returns {Promise<any>}
 */

export function getMobileMpInfo(params) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)

    let urlParams = {
      ...commonOrderParams,
      pf: params.pf,
      drm_info: params.drm_info,
      ...helper.getLoginState({
        openid: params.openid,
        openkey: params.openkey,
        sessionId: params.sessionId,
        sessionType: params.sessionType,
        wxAppid2: params.wxAppid2,
        qqAppid: params.qqAppid
      }),
      appversion: "",
      change_wx_openid: 1,
      type: "bg", // 道具：bg，游戏币：save，包月：month，月卡：unimonth，不传默认为save
      session_token: uuid.generate() + new Date().getTime(),
      r: Math.random(),
      webversion: params.webversion || "h5storeV1.0.0"
    }
    urlParams = Object.assign(urlParams, aes.encrypt(urlParams, ["openid", "openkey", "session_id", "session_type"], params.sandbox))

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/mobile_mp_info`,
        data: urlParams,
        type: "post"
      })
      .then(
        res => {
          if (res.ret == 0) {
            resolve(res)
          } else {
            reject(res)
          }
        },
        () => {
          reject({
            msg: "timeout"
          })
        }
      )
  })
}

/**
 * 查询券列表
 * reward_pf_query
 * @param params
 * @returns {Promise<any>}
 */
export function getRewardCouponList(params, extendParams = {}) {
  return new Promise((resolve, reject) => {
    let urlParams = {
      offer_id: params.offerId,
      ...commonOrderParams,
      pf: params.pf,
      drm_info: params.drm_info,
      ...helper.getLoginState({
        openid: params.openid,
        openkey: params.openkey,
        sessionId: params.sessionId,
        sessionType: params.sessionType,
        wxAppid2: params.wxAppid2,
        qqAppid: params.qqAppid
      }),
      action: "query_coupon_list",
      r: Math.random(),
      webversion: params.webversion || "h5storeV1.0.0",
      format: "jsonp__getRewardCouponList",
      ...extendParams
    }
    urlParams = Object.assign(urlParams, aes.encrypt(urlParams, ["openid", "openkey", "session_id", "session_type"], params.sandbox))

    let url = "pay.qq.com/cgi-bin/rewardpf"
    if (params.sandbox == 2) {
      url = "dev.api.unipay.qq.com/cgi-bin"
    } else if (params.sandbox == 1) {
      url = "sandbox.pay.qq.com/cgi-bin/rewardpf"
    }

    request
      .jsonp({
        url: `//${url}/reward_pf_query.fcg`,
        data: urlParams,
        jsonpCallbackName: "_getRewardCouponList"
      })
      .then(
        res => {
          if (res.ret == 0) {
            resolve(res)
          } else {
            reject(res)
          }
        },
        () => {
          reject({
            msg: "timeout"
          })
        }
      )
  })
}

/**
 * 兑换券列表
 * reward_pf_query
 * @param params
 * coupon_serialno
 * @returns {Promise<any>}
 * wx
 * coupon_serialno: state.couponDetail.coupon_serialno,
   extend: encodeURIComponent(serializeParam({
     session_id: 'wechatid',
     provide_uin: state.wechatSession.openid,
     wx_appid: state.wechatSession.appid
   }))

   qq
   coupon_serialno: state.couponDetail.coupon_serialno,
   provide_uin: opt.provide_uin
 */
export function exchangeCoupon(params) {
  return new Promise((resolve, reject) => {
    if (params.coupon_serialno) {
      let urlParams = {
        change_wx_openid: 1,
        zoneid: params.zoneid,
        game_platform_id: params.game_platform_id || "",
        gameid: params.gameid || "",
        offer_id: params.offerId,
        ...commonOrderParams,
        pf: params.pf,
        ...helper.getLoginState({
          openid: params.openid,
          openkey: params.openkey,
          sessionId: params.sessionId,
          sessionType: params.sessionType,
          wxAppid2: params.wxAppid2,
          qqAppid: params.qqAppid
        }),
        coupon_serialno: params.coupon_serialno,
        action: "coupon_exchange",
        r: Math.random(),
        webversion: params.webversion || "h5storeV1.0.0"
      }
      // if (params.accounttype === "wx") {
      //   urlParams.extend = request.serializeParams({
      //     session_id: "wechatid",
      //     provide_uin: params.openid,
      //     wx_appid: params.wxAppid2
      //   })
      // } else {
      //   urlParams.provide_uin = params.openid
      // }
      if (params.groupid) {
        urlParams.drm_info = `group_id=${params.groupid}&version=3.0`
      }

      urlParams = Object.assign(urlParams, aes.encrypt(urlParams, ["openid", "openkey", "session_id", "session_type"], params.sandbox))

      let env = helper.getCgiEnv(params.sandbox)
      let url = "//pay.qq.com/cgi-bin/rewardpf/reward_pf_exchange_front.fcg"
      if (params.sandbox == 2) {
        url = "//" + env + "api.unipay.qq.com/v1/r/" + params.offerId + "/reward_pf_exchange_front"
      } else if (params.sandbox == 1) {
        // 没有使用sandbox.pay.qq.com是因为跨域限制
        url = "//sandbox.quanyi.qq.com/cgi-bin/rewardpf/reward_pf_exchange_front.fcg"
      }

      request
        .ajax({
          url: url,
          data: urlParams,
          type: "post"
        })
        .then(
          res => {
            if (res.ret == 0) {
              resolve(res)
            } else {
              reject(res)
            }
          },
          () => {
            reject({
              msg: "timeout"
            })
          }
        )
    } else {
      reject({
        msg: "券id缺失"
      })
    }
  })
}

/**
 * 查询外部渠道配置的物品列表,暂支持微信游戏中心渠道
 * wechat_query
 * @param params
 * @returns {Promise<any>}
 */
export function getOuterGoodsList(params) {
  return new Promise((resolve, reject) => {
    if (!params.offerId) {
      reject({
        msg: "offerId缺失"
      })
    }
    let env = helper.getCgiEnv(params.sandbox)
    let urlParams = {
      cmd: 31,
      ...commonOrderParams,
      change_wx_openid: 1,
      pf: params.pf,
      group_id: params.groupId,
      ...helper.getLoginState({
        openid: params.openid,
        openkey: params.openkey,
        sessionId: params.sessionId,
        sessionType: params.sessionType,
        wxAppid2: params.wxAppid2,
        qqAppid: params.qqAppid
      }),
      r: Math.random(),
      webversion: params.webversion || "h5storeV1.0.0"
    }
    urlParams = Object.assign(urlParams, aes.encrypt(urlParams, ["openid", "openkey", "session_id", "session_type"], params.sandbox))

    request
      .ajax({
        url: "//" + env + "api.unipay.qq.com/v1/r/" + params.offerId + "/wechat_query",
        data: urlParams,
        type: "post"
      })
      .then(
        res => {
          if (res.ret == 0) {
            resolve(res)
          } else {
            reject(res)
          }
        },
        () => {
          reject({
            msg: "timeout"
          })
        }
      )
  })
}

/**
 * 添加reward pf query cgi调用情况
 * @param params 用户控制请求流程的参数，不能传给cgi，如sandbox环境参数等
 * @param extendParams 直接传递给cgi的参数
 * @returns {Promise}
 */
export function rewardPfQuery(params, extendParams) {
  return new Promise((resolve, reject) => {
    let data = {
      r: Math.random(),
      pfkey: "pfkey",
      from_h5: 1,
      from_https: 1
    }

    data = Object.assign(data, extendParams, aes.encrypt(extendParams, ["openid", "openkey", "session_id", "session_type"], params.sandbox))

    let url = "pay.qq.com/cgi-bin/rewardpf"

    if (params.sandbox == 2) {
      url = "dev.api.unipay.qq.com/cgi-bin"
    } else if (params.sandbox == 1) {
      url = "sandbox.pay.qq.com/cgi-bin/rewardpf"
    }

    request
      .ajax({
        url: `//${url}/reward_pf_query.fcg`,
        data: data
      })
      .then(
        res => {
          if (res.ret == 0) {
            resolve(res)
          } else {
            reject(res)
          }
        },
        () => {
          reject({
            msg: "timeout"
          })
        }
      )
  })
}

/**
 * 通用兑换接口，上面的exchagneCoupon没有允许透传参数
 * 这里还是新建一个专门兑换的cgi的接口，里面可以透传各种 action 及参数
 * @param params
 * @param extendParams
 * @returns {Promise}
 */
export function rewardPfExchangeFront(params, extendParams) {
  return new Promise((resolve, reject) => {
    let data = {
      r: Math.random(),
      pfkey: "pfkey",
      from_h5: 1,
      from_https: 1
    }

    data = Object.assign(data, extendParams, aes.encrypt(extendParams, ["openid", "openkey", "session_id", "session_type"], params.sandbox))

    let env = helper.getCgiEnv(params.sandbox)

    let url = "//pay.qq.com/cgi-bin/rewardpf/reward_pf_exchange_front.fcg"

    if (params.sandbox == 2) {
      url = "//" + env + "api.unipay.qq.com/v1/r/" + params.offerId + "/reward_pf_exchange_front"
    } else if (params.sandbox == 1) {
      // 没有使用sandbox.pay.qq.com是因为跨域限制
      url = "//sandbox.quanyi.qq.com/cgi-bin/rewardpf/reward_pf_exchange_front.fcg"
    }

    request
      .ajax({
        url: url,
        data: data,
        type: "post"
      })
      .then(
        res => {
          if (res.ret == 0) {
            resolve(res)
          } else {
            reject(res)
          }
        },
        () => {
          reject({
            msg: "timeout"
          })
        }
      )
  })
}

/**
 * 查询coupon_serialno详情
 * @param params
 * @returns {Promise}
 */
export function queryUserRedeemAmsCouponDetail(params) {
  return rewardPfQuery(
    {
      sandbox: params.sandbox
    },
    {
      action: "query_coupon_detail",
      offer_id: params.offerId,
      coupon_serialno: params.couponId,
      coupon_pid: params.productId,
      ...helper.getLoginState(params.loginState)
    }
  )
}

/**
 * 查询cdkey_serialno详情
 * @param sandbox
 * @param offerId
 * @param bizOfferId 代理商offerId
 * @param cdkeySerialNum
 * @param loginState
 * @param pf
 */
export function queryCDKeyDetail(params) {
  return rewardPfQuery(
    {
      sandbox: params.sandbox
    },
    {
      action: "query_online_cdkey_info",
      offer_id: params.offerId,
      cdkey_serialno: params.cdkeySerialNum,
      ...helper.getLoginState(params.loginState),
      pf: params.pf
    }
  )
}

/**
 * 查询物品详情
 * @param params
 * @returns {Promise}
 */
export function queryCouponProductDetail(params) {
  return rewardPfQuery(
    {
      sandbox: params.sandbox
    },
    {
      action: "query_pidlist_by_couponpid",
      offer_id: params.offerId,
      coupon_pid: params.productId,
      ...helper.getLoginState(params.loginState)
    }
  )
}

/**
 * CDKey兑换
 * @param sandbox
 * @param offerId
 * @param bizOfferId 代理商offerId
 * @param loginState
 * @param cdkeySerialNum
 * @param gameid
 * @param game_platform_id
 * @param pf
 * @returns {Promise}
 */
export function cdkeyExchange(params) {
  return new Promise((resolve, reject) => {
    const { openid, openkey, sessionId, sessionType, wxAppid2, qqAppid } = params.loginState
    let param = {
      pf: params.pf,
      openid,
      openkey,
      sessionid: sessionId,
      sessiontype: sessionType,
      wxAppid2: wxAppid2,
      qqAppid,
      cdkey_serialno: params.cdkeySerialNum,
      gameid: params.gameid,
      game_platform_id: params.game_platform_id,
      appid: params.offerId,
      sandbox: params.sandbox,
      tx_chan_type: params.tx_chan_type,
      tx_seller_id: params.tx_seller_id,
      onSuccess: function () {
        resolve()
      },
      onError: function () {
        reject()
      },
      onClose: function () {
        reject()
      }
    }
    Midas.rewardExchange(param)
  })
}

/**
 * 兑换券
 * @param params
 * @returns {Promise}
 */
export function redeemAmsCoupon(params) {
  return rewardPfExchangeFront(
    {
      sandbox: params.sandbox,
      offerId: params.offerId
    },
    {
      action: "coupon_exchange",
      offer_id: params.offerId,
      ...helper.getLoginState(params.loginState),
      product_id: params.product_id,
      coupon_serialno: params.couponId,
      pf: params.pf,
      gameid: params.gameid,
      game_platform_id: params.game_platform_id
    }
  )
}

/**
 * 通过 details 接口查询指定商店下商品的详细信息
 *
 * 调用 txcz/node/api/vmall/detail
 */
export function getGoodsDetail(params) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)
    let apiParams = {
      from_https: 1,
      from_h5: 1,
      pf: params.pf,
      pfkey: "pfkey",
      t: +new Date(),
      storeId: params.storeId,
      goodsId: params.goodsId,
      ...params.loginState
    }

    let data = Object.assign(apiParams, aes.encrypt(apiParams, ["openid", "openkey", "session_id", "session_type"], params.sandbox))
    request
      .ajax({
        url: `//${env}pay.qq.com/txcz/node/api/vmall/detail`,
        data: data
      })
      .then(res => {
        // ret == 0 说明请求没有问题
        // res.data 存在 说明请求获得了内容
        if (res.ret == 0 && res.data) {
          resolve(res.data)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

/**
 * 获取用户拥有礼品卡数量
 * @param params
 * @returns {Promise}
 */
export function getUserGiftCardNum(params = {}) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)
    const { offer_id = "", area = "", platid = "", partition = "", gift_card_ids = [] } = params
    let data = {
      gift_card_ids,
      offer_id,
      area,
      platid,
      partition,
      t: +new Date(),
      ...params.loginState
    }

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/trpc.txcz_store.gift_card.Greeter/GetGiftCardNum`,
        data: data,
        type: "post",
        requestContentType: "application/json",
        contentType: "json"
      })
      .then(res => {
        // ret == 0 说明请求没有问题
        // res.gift_card_nums 存在 说明请求获得了内容
        if (res?.ret == 0 && res?.gift_card_nums) {
          resolve(res.gift_card_nums)
        } else {
          reject(res)
        }
      })
      .catch(e => {
        reject(e)
      })
  })
}

/**
 * 获取礼品卡可兑礼品
 * @param params
 * @returns {Promise}
 */
export function getProductIdOnGiftCard(params = {}) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)
    const { pf = "", offer_id = "", gift_card_ids = [] } = params
    let data = {
      gift_card_ids,
      pf,
      offer_id,
      t: +new Date(),
      ...params.loginState,
      // openid 后端入参格式为字符串，所以转一下字符串类型
      openid: params.loginState.openid + ""
    }

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/trpc.txcz_store.gift_card.Greeter/GetProductIdOnGiftCard`,
        data: data,
        type: "post",
        requestContentType: "application/json",
        contentType: "json"
      })
      .then(res => {
        // ret == 0 说明请求没有问题
        if (res?.ret == 0 && res?.info) {
          resolve(res.info)
        } else {
          reject(res)
        }
      })
      .catch(e => {
        reject(e)
      })
  })
}

export function getGiftCardInfo(params = {}) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)
    request
      .ajax({
        url: `//${env ? "sandbox." : ""}pay.qq.com/h5/store_config/props_receive/props_receive/${params.offer_id}.json`,
        data: {
          timestamp: +new Date()
        }
      })
      .then(res => {
        if (res) {
          resolve(res)
        } else {
          reject("")
        }
      })
      .catch(e => {
        reject(e)
      })
  })
}
